<template>
  <mdb-container>
    <mdb-autocomplete
      v-model="selection"
      :data="searchResults"
      :label="searchLabel"
      @clear="clearSearch"
      @search="handleSearch"
    />
  </mdb-container>
</template>

<script>
import { mdbAutocomplete, mdbContainer } from "mdbvue";
export default {
  name: "GooglePlaces",
  components: {
    mdbAutocomplete,
    mdbContainer
  },
  props: {
    searchLabel: String,
  },
  data: () => ({
    location: "",
    selection: null,
    searchResults: [],
    autoCompleteService: null,
    placesService: null,
    placesServiceRequest: {
      placeId: "",
      fields: [
        "name",
        "formatted_address",
        "website",
        "international_phone_number",
        "geometry"
      ]
    }
  }),
  created: function() {
    this.mapsInit();
  },
  /*metaInfo() {
    return {
      script: [
        {
          src: `https://maps.googleapis.com/maps/api/js?key=AIzaSyClGxm8zPkdeO3Hgtt8N6zcf4ekIINCRJY&libraries=places`,
          async: true,
          defer: true,
          callback: () => this.mapsInit() // will declare it in methods
        }
      ]
    };
  },*/
  methods: {
    handleSearch(val) {
      this.location = val;
      console.log(val);
    },
    clearSearch() {
      this.$emit("place-result", null);
    },
    mapsInit() {
      this.autoCompleteService = new window.google.maps.places.AutocompleteService();
      this.placesService = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
    },
    fillFieldsFromRequest(place, status) {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        this.$emit("place-result", place);
      }
      console.log(place, status);
    },
    displaySuggestions(predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        this.searchResults = [];
        return;
      }
      this.searchResults = predictions.map(
        prediction => prediction.description + "(" + prediction.place_id + ")"
      );
    }
  },
  watch: {
    selection(newValue) {
      if (newValue) {
        this.placesServiceRequest.placeId = newValue.substring(
          newValue.lastIndexOf("(") + 1,
          newValue.lastIndexOf(")")
        );
        this.placesService.getDetails(
          this.placesServiceRequest,
          this.fillFieldsFromRequest
        );
        console.log(newValue);
      }
    },
    location(newValue) {
      if (newValue) {
        this.autoCompleteService.getPlacePredictions(
          {
            input: this.location,
            componentRestrictions: { country: ["fi"] }
          },
          this.displaySuggestions
        );
      }
    }
  }
};
</script>

<style></style>
